module.exports = __webpack_public_path__ + "static/media/tti_weekly_offers@3x.262491ff.png";